/**
 * A custom function to log errors in the application.
 *
 * This function checks if the UI is in debug mode. If it is, it logs the error
 * using the console.log() method. If not, it does nothing.
 */

export const ErrorLog = (errorType: string, errorMessage?: any) => {
  const isDebug = window.isHQIUIDebug;
  if (isDebug !== undefined && isDebug !== null && isDebug) {
    // eslint-disable-next-line no-console
    console.log(errorType + ":=> " + errorMessage);
  }
  
};
